<div class="dasboard-container layout-dashboard drawer-small">
    <div class="content-body">
        <div class="left-sidebar side-nav">
            <aside class="left-sidebar" mode="side">
                <div class="brand" tabindex="0">
                    <img class="small-logo" src="/assets/images/global/brand/brand-small.svg" alt="Countable" />
                </div>

                <mat-list role="list" class="left-nav">
                    <mat-list-item role="list-item">
                        <span class="active nav-item" title="Client Onboarding">
                            <span class="nav-icon">
                                <img src="/assets/images/ui-uplift-icons/global/nav-icons/clients.svg" alt="Icon">
                            </span>
                            <span class="nav-label">Client Onboarding</span>
                        </span>
                    </mat-list-item>
                </mat-list>
            </aside>
        </div>
        <div class="dashboard-main">
            <div class="page-title-block">
                <div class="title-left">
                    <h1 class="title h3">Account Setup</h1>
                </div>
            </div>
            <div class="content-block-main gap-20">

                <mat-accordion multi="true" class="d-flex flex-column gap-20">
                    <mat-expansion-panel class="card" [expanded]="true" [disabled]="false">
                        <mat-expansion-panel-header class="card-header">
                            <mat-panel-title>Step 1: Firm Info</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="client-details card-body">
                            <ul>
                                <li class="flex-box-left">
                                    <div class="client-details-left">
                                        <p>Firm Name</p>
                                        <h6>{{firmDetails.firmName}}</h6>
                                    </div>
                                    <div class="client-details-right">
                                        <p>Partner Name</p>
                                        <h6>{{firmDetails.partnerName}}</h6>
                                    </div>
                                </li>
                                <li class="flex-box-left">
                                    <div class="client-details-left">
                                        <p>Business Phone</p>
                                        <h6>{{firmDetails.firmBusinessPhoneNo}}</h6>
                                    </div>
                                    <div class="client-details-right">
                                        <p>Cell Phone</p>
                                        <h6>{{firmDetails.firmCellPhoneNo}}</h6>
                                    </div>
                                </li>
                                <li class="flex-box-left">
                                    <div class="client-details-left">
                                        <p>Email ID</p>
                                        <h6>{{firmDetails.firmEmailAddress}}</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="card">
                        <mat-expansion-panel-header class="card-header">
                            <mat-panel-title>Step 2: Client Info</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="card-body">
                            <form [formGroup]="clientDetailsForm" autocomplete="off" class="d-flex flex-column gap-20">
                                <div class="form-group row-items-3">
                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Legal Entity Name</mat-label>
                                        <input matInput placeholder="Legal Entity Name"
                                            formControlName="legalEntityName" required maxlength="100">
                                    </mat-form-field>

                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Contact Person</mat-label>
                                        <input matInput placeholder="Contact Person" title="Contact Person"
                                            formControlName="contactPersonName" (input)="onlyChars($event,'cp')"
                                            required maxlength="100">
                                    </mat-form-field>

                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Business Phone</mat-label>
                                        <input matInput placeholder="Business Phone" formControlName="businessPhone"
                                            (input)="handlePhone($event,'business')" minlength="14" maxlength="14"
                                            appDisableAutofill>
                                    </mat-form-field>

                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Cell Phone</mat-label>
                                        <input matInput placeholder="Cell Phone" formControlName="cellPhone"
                                            (input)="handlePhone($event,'cell')" minlength="14" maxlength="14"
                                            appDisableAutofill>
                                    </mat-form-field>

                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Email</mat-label>
                                        <input matInput placeholder="Email" formControlName="clientEmail" required
                                            maxlength="100" (input)="onlyLowercase($event)">
                                    </mat-form-field>

                                    <div class="form-item ng-form-field">
                                        <label>Entity Type<span class="required">*</span></label>
                                        <ng-select [items]="typeOfEntityDetails" bindLabel="typeofentityname"
                                            bindValue="typeofentityid" [virtualScroll]="true" [clearable]="false"
                                            [selectOnTab]="true" formControlName="typeOfEntity"
                                            (change)="onEntityChange()" placeholder="Entity Type"
                                            class="typo-head-dropdown1 team-dropdown type-ent" required>
                                        </ng-select>
                                    </div>

                                    <div class="form-item fixed-label icon-field-after">
                                        <app-countable-date [isMaxDate]="true" (selectedDate)="checkDates($event)"
                                            [label]="customDateTitle" [placeholderText]="'MM/DD/YYYY'"
                                            [subLabel]="'(MM/DD/YYYY)'"
                                            [inputDate]="clientDetailsForm.controls['incorporationDate'].value"></app-countable-date>
                                    </div>

                                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                                        <mat-label>Jurisdiction of Entity</mat-label>
                                        <input appFullAddress matInput placeholder="Jurisdiction of Entity"
                                            formControlName="jurisdiction" type="address"
                                            (addressChange)="onAddressType($event)"
                                            onfocus="this.setAttribute('autocomplete', 'new-password')"
                                            [matAutocomplete]="fullAddress">
                                        <mat-autocomplete #fullAddress="matAutocomplete"
                                            (optionSelected)="selectedSuggestion($event)">
                                            @for (option of autoCompleteSuggestions(); track option) {
                                            <mat-option class="map-option" [value]="option">{{option.displayName}}</mat-option>
                                            }
                                        </mat-autocomplete>
                                    </mat-form-field>

                                    <input type="hidden" name="country" formControlName="country">

                                </div>

                                <div class="button-group justify-content-end">
                                    <button mat-button type="submit" mat-flat-button class="button-default"
                                        color="primary" (click)="saveClientDetails('save')"
                                        [disabled]="!clientDetailsForm.valid">
                                        Save
                                    </button>
                                </div>

                            </form>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="card" [expanded]="showStep3" [disabled]="disableStep3">
                        <mat-expansion-panel-header class="card-header">
                            <mat-panel-title>Step 3: Integrations</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="card-body">
                            <ng-container>
                                <div class="cust-section-wrapper integrations-setup-container">
                                    <div class="integrations-setup-row"
                                        *ngFor="let filedata of csvDetails; let i= index">
                                        <div class="integrations-setup-row-left" title="{{filedata.JsonFileName}}">
                                            <h5>{{filedata.JsonFileName}}</h5>
                                        </div>
                                        <div class="integrations-setup-row-right">
                                            <div class="integrations-setup-actions">
                                                <button mat-flat-button class="button-integrations"
                                                    (click)="deleteParticularFileModel(filedata)">
                                                    <i class="fa-regular fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- integration -->
                            <!-- while waiting for response, show wait icon -->
                            <div *ngIf="!dataLoaded" style="margin: 50px 50px;">
                                <img src="/assets/images/loader.gif" style="width: 40px; height: 40px;"
                                    alt="loading ...">
                            </div>

                            <!-- data is loaded -->
                            <ng-container *ngIf="dataLoaded">
                                <!-- source is connected -->
                                <ng-container *ngIf="tenantInfo && integration">
                                    <!-- when there is next step like sage organization select -->
                                    <ng-container *ngIf="integration.needExtraStepAfterAuth && !tenantInfo.tenant">
                                        <div class="integrations-organizations-box">
                                            <div class="integrations-organizations-box-header">
                                                <img src="/assets/images/sage-logo.png" alt="Sage" />
                                            </div>
                                            <div class="integrations-organizations-box-content">
                                                <h3>Please Select your company</h3>
                                            </div>
                                            <div class="integrations-organizations-box-dropdown">
                                                <label>Please select your business<em style="color: red;">*</em>
                                                    :</label>
                                                <ng-select appearance="outline" [items]="organizationsList"
                                                    bindLabel="organization" class="ng-patner"
                                                    [placeholder]="selectedOrganization != null ? '': 'Please select your business'"
                                                    [(ngModel)]="selectedOrganization">
                                                </ng-select>
                                            </div>
                                            <div class="integrations-organizations-box-footer">
                                                <div class="integrations-organizations-box-footer-buttons">
                                                    <button mat-stroked-button (click)="disconnect()"
                                                        class="cancel-btn">
                                                        Cancel
                                                    </button>
                                                    <button mat-stroked-button [disabled]="selectedOrganization == null"
                                                        (click)="saveOrganization()" class="next-btn">
                                                        Finish
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <!-- when there is no next step -->
                                    <ng-container
                                        *ngIf="!integration.needExtraStepAfterAuth || (integration.needExtraStepAfterAuth && tenantInfo.tenant)">
                                        <div class="integrations-setup-header">
                                            <h4><span *ngIf="!connectionStatus">Was </span>Connected to:</h4>
                                        </div>
                                        <div class="integrations-setup-row">
                                            <div class="integrations-setup-row-left">
                                                <div>
                                                    <button class="button-integrations" title="{{integration.label}}">
                                                        <span class="btn-label">
                                                            <img style="height: 55px; border: none;"
                                                                src="{{integration.imgPathLogo}}"
                                                                alt="{{integration.label}}" />
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div [ngClass]="{'strike-text': !connectionStatus}"
                                                class="integrations-setup-row-center" *ngIf="tenantInfo !== null">
                                                <p>{{tenantInfo.organization}}</p>
                                            </div>
                                            <div class="integrations-setup-row-right">
                                                <div class="integrations-setup-actions">
                                                    <button class="btn transparent-btn"
                                                        (click)="openDisconnectPopup(integration)">
                                                        <img src="{{integration.imgPathDisconnect}}" height="43px"
                                                            alt="Disconnect" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <h5 class="fade-in"
                                            style="color: #d93540; margin-bottom: 10px; margin-top: 10px;"
                                            *ngIf="!connectionStatus">The connection is broken, please authorize
                                            Countable to your client
                                            again by disconnect and connect it again.</h5>
                                    </ng-container>
                                </ng-container>
                                <!-- no source is connected, show all sources -->
                                <ng-container *ngIf="!tenantInfo">
                                    <div class="integrations-setup-header">
                                        <h4>Choose one of the accounting software integrations:</h4>
                                    </div>
                                    <div class="integrations-setup-row account-height-adj">
                                        <div class="flex-box-row upload-integration-container">
                                            <div class="integration-box">
                                                <ng-container *ngFor="let i of integrations">
                                                    <div class="integration-item">
                                                        <button class="integration-button" title="{{i.name}}"
                                                            (click)="oauthKickOff(i)">
                                                            <img class="integration-img-connect"
                                                                src="{{i.imgPathConnect}}" alt="{{i.label}}" />
                                                        </button>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <!-- End Integration -->

                            <div class="flex-box-right">
                                <div class="integrations-actions" *ngIf="!integrationAvailable">
                                    <button mat-button class="button-text" (click)="enableComplete = true">Skip for
                                        later
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                </mat-accordion>
                <div class="button-group justify-content-end">
                    <button mat-button mat-flat-button class="button-default" color="primary" (click)="validateData()"
                        [disabled]="!integrationAvailable || disableStep3 ? !enableComplete : enableComplete"
                        [ngClass]="{'disable-button': !integrationAvailable || disableStep3 ? !enableComplete : enableComplete}">
                        Complete
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #alertDialog>
    <div mat-dialog-content class="dialogBox">
        <div class="elem-p">
            <div class="elem-c">
                <div class="elem-p">
                    <div class="elem-c">
                    </div>
                </div>
                <h5>There are pending changes. Do you want to save them?</h5>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialogBoxActions">
        <button mat-raised-button class="secondary-btn l30 float-left" color="secondary" [mat-dialog-close]
            (click)="completeOnboarding()">
            No
        </button>
        <button mat-raised-button class="secondary-btn l30 float-right" color="primary" [mat-dialog-close]
            (click)="saveAndCompleteOnboarding()">
            Yes
        </button>
    </div>

</ng-template>

<!-- delete connection popup-->
<ng-template #disconnectDialog>
    <div class="countable-dialog confirmation-dailog disconnectDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Disconnect</h4>
            <img src="{{integration.imgPathLogo}}" alt="{{integration.label}}" style="max-height: 30px;">
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p class="fw-semibold">Are you sure you want to disconnect from {{integration.label}}?</p>
            <p>You will be losing all engagement data</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark"
                [mat-dialog-close]="false">No</button>
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
                (click)="disconnect()">Yes</button>
        </div>
    </div>
</ng-template>


<!-- delete particular file popup-->
<ng-template #csvDeleteDialog>
    <div mat-dialog-content class="dialogBox">
        <button class="transparent-btn float-right close-btn" [mat-dialog-close]>
            <i class="fa-regular fa-xmark clear-icon"></i>
        </button>
        <div class="elem-p">
            <div class="elem-c">
                <!-- <span class="icon-lock ioc loc-img"></span> -->
                <div class="col-md-12">
                    <p><strong>Are you sure do you want to delete <b>{{csvDetailsForDelete.JsonFileName}}</b>?</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialogBoxActions">
        <button type="button" mat-raised-button class="secondary-btn float-left" color="secondary" [mat-dialog-close]>
            Cancel
        </button>
        <button mat-raised-button class="secondary-btn float-right" color="primary" (click)="deleteCsvfromDB()"
            [mat-dialog-close]="animal">
            Yes
        </button>
    </div>
</ng-template>